import React, { useState, useEffect } from 'react';
import Navbar from '../components/Navbar';
import { FaChartBar, FaCogs, FaBullseye } from 'react-icons/fa';
import ProductManagement from '../components/ProductManagement';
import OperationManagement from '../components/OperationManagement';
import StrategicManagement from '../components/StrategicManagement';
import Footer from '../components/Footer';
import { useNavigate } from "react-router-dom";
import OperationManagementNew from '../components/OperationManagementNew';

export default function HomeTabs() {
  const [activeTab, setActiveTab] = useState('product');

  const navigate = useNavigate();
  const [darkMode, setDarkMode] = useState(false);
   useEffect(() => {
     const adminId = localStorage.getItem("adminID");
     if (!adminId) {
       navigate("/"); 
     }
 
     // 👇 load dark mode preference
     const savedTheme = localStorage.getItem("darkMode") === "true";
     setDarkMode(savedTheme);
     document.body.classList.toggle("dark", savedTheme);
   }, [navigate]);


  // Load tab from hash on initial render
  useEffect(() => {
    const hash = window.location.hash.replace('#', '');
    if (hash === 'product' || hash === 'operations' || hash === 'strategy') {
      setActiveTab(hash);
    }
  }, []);

  // Update hash when activeTab changes
  const handleTabChange = (tab) => {
    setActiveTab(tab);
    window.location.hash = tab; // Updates URL
    window.location.reload();
  };

  return (
    <>
 

      <div className="container-fluid mt-2">
        <div className={`d-flex gap-3 bg-white-bg1 ${darkMode ? "dark" : ""}  p-2 rounded justify-content-between`}>
          <button
            className={`btn tab-btn w-100 ${activeTab === 'product' ? 'active-tab tab1' : ''}`}
            onClick={() => handleTabChange('product')}
          >
            <span
  className={`mainttl ${
    darkMode ? "dark" : ""
  } ${activeTab === "product" ? "text-white" : ""}`}
>
  <FaChartBar className="me-2" />
  Product Management
</span>
            
          </button>

          <button
            className={`btn tab-btn w-100 ${activeTab === 'operations' ? 'active-tab tab2' : ''}`}
            onClick={() => handleTabChange('operations')}
          >
<span
  className={`mainttl ${
    darkMode ? "dark" : ""
  } ${activeTab === "operations" ? "text-white" : ""}`}
>
  <FaCogs className="me-2" />
  Operational Management
</span>

          
          </button>

          <button
            className={`btn tab-btn w-100 ${activeTab === 'strategy' ? 'active-tab tab3' : ''}`}
            onClick={() => handleTabChange('strategy')}
          >
             <span
  className={`mainttl ${
    darkMode ? "dark" : ""
  } ${activeTab === "strategy" ? "text-white" : ""}`}
>
  <FaBullseye className="me-2" />
  Strategic Management
</span>
            
          </button>
        </div>

        {/* <div className="mt-4">
          {activeTab === 'product' && <ProductManagement />}
          {activeTab === 'operations' && <OperationManagementNew />}
          {activeTab === 'strategy' && <StrategicManagement />}
        </div> */}
      </div>

    
    </>
  );
}
